<dx-popup
    #workflowNotesPopup
    minWidth="150px"
    minHeight="150px"
    width="30%"
    height="50%"
    title="Notes For AAP Workflow #{{ workflowId }}"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onWorkflowNotesPopShown()"
    (onHidden)="onWorkflowNotesPopClose()"
>
    <div *dxTemplate="let data of 'content'">
        <app-notes-editor
            #workflowNotes
            *ngIf="!readOnly"
            [previousNotes]="previousWorkflowNotes"
            [previousNotesVisible]="true"
            (onNotesPopUpClose)="onWorkflowNotesPopClose()"
            (onNewNotesSave)="onSaveWorkflowNotes($event)"
        ></app-notes-editor>

        <app-notes-viewer
            #workflowViewerNotes
            *ngIf="readOnly && previousWorkflowNotes"
            [previousNotes]="previousWorkflowNotes"
            (notesPopUpClose)="onWorkflowViewerNotesPopClose()"
        ></app-notes-viewer>
    </div>
</dx-popup>
